/* ==========================================================================
   Solzaleben, vloeren-productpagina (template product.boden)

   Alleen interactie; alle inhoud staat al server-side in de HTML.
   - Rekenhulp: m² → pakken (met verschnitt), totaal, besparing, minimum.
   - Leverdatum opnieuw uitrekenen in werkdagen (ma t/m vr): de HTML kan
     uit Shopify's cache komen.
   - Toebehoren: accordeons en kiezen; de keuze gaat mee bij "In den Warenkorb".
   - Proefmonster: onze kaart stuurt de knop van de Product Samples-app aan.
   Faalt er iets, dan blijft de pagina bruikbaar en komt er niets in de console.
   ========================================================================== */
(function () {
  'use strict';

  var EUR = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  // Oppervlaktes: minstens 2, hooguit 3 decimalen (pakketinhoud 1,638 m² × 5 = 8,19 m²).
  var NUM2 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 3 });
  var DAGEN = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];

  function euro(cent) {
    return EUR.format(cent / 100);
  }

  // "8", "8,5", "8.5" → 8.5; leeg of ongeldig → NaN.
  function leesGetal(waarde) {
    var tekst = String(waarde || '').trim().replace(/\s/g, '').replace(',', '.');
    if (tekst === '' || !/^\d*\.?\d*$/.test(tekst)) return NaN;
    return parseFloat(tekst);
  }

  function schrijfGetal(getal) {
    // Hele getallen zonder decimalen, anders met komma.
    var afgerond = Math.round(getal * 100) / 100;
    return afgerond % 1 === 0 ? String(afgerond) : NUM2.format(afgerond);
  }

  /* ------------------------------------------------------------------------
     Rekenhulp
     ------------------------------------------------------------------------ */

  function initKoop(root) {
    var form = root.querySelector('form.solza-pdp-form');
    if (!form) return;

    var pak = parseFloat(root.dataset.pak) || 0;
    var perPak = pak <= 0; // zonder pakketinhoud: invoer in pakken
    var prijs = parseInt(root.dataset.prijs, 10) || 0;
    var uvp = parseInt(root.dataset.uvp, 10) || 0;
    var snijverlies = parseInt(root.dataset.snijverlies, 10) || 0;
    var minPakete = Math.max(1, parseInt(root.dataset.minPakete, 10) || 1);
    var voorraad = parseInt(root.dataset.voorraad, 10);
    var uitverkocht = form.querySelector('[name="id"]').disabled;

    var veld = form.querySelector('[data-solza-flaeche]');
    var qty = form.querySelector('[data-solza-qty]');
    var submit = form.querySelector('[data-solza-submit]');
    var paketeEl = form.querySelector('[data-solza-pakete]');
    var totaalEl = form.querySelector('[data-solza-totaal]');
    var sparenEl = form.querySelector('[data-solza-sparen]');
    var minimum = form.querySelector('[data-solza-minimum]');
    var minimumTekst = form.querySelector('[data-solza-minimum-tekst]');
    var genoeg = form.querySelector('[data-solza-genoeg]');
    var verschnittKnop = form.querySelector('[data-solza-verschnitt]');
    var verschnittTekst = form.querySelector('[data-solza-verschnitt-tekst]');
    var minKnop = form.querySelector('[data-solza-naar-minimum]');
    var hint = form.querySelector('[data-solza-hint]');
    var metVerschnitt = snijverlies > 0 && !perPak;

    function pakketten(invoer) {
      if (!(invoer > 0)) return 0;
      if (perPak) return Math.ceil(invoer - 1e-9);
      var nodig = invoer * (metVerschnitt ? 1 + snijverlies / 100 : 1);
      return Math.ceil(nodig / pak - 1e-9);
    }

    function paketeTekst(n) {
      return n + (n === 1 ? ' Paket' : ' Pakete');
    }

    function zetKnop(aan) {
      submit.disabled = !aan;
      submit.setAttribute('aria-disabled', aan ? 'false' : 'true');
    }

    function bereken() {
      var invoer = leesGetal(veld.value);
      var n = pakketten(invoer);
      var onderMinimum = n < minPakete;

      qty.value = String(n);

      if (n > 0) {
        var oppervlak = n * pak;
        paketeEl.innerHTML = '';
        var sterk = document.createElement('strong');
        sterk.textContent = paketeTekst(n);
        paketeEl.appendChild(sterk);
        if (!perPak) paketeEl.appendChild(document.createTextNode(' = ' + NUM2.format(oppervlak) + ' m²'));
        totaalEl.textContent = euro(n * prijs);
        if (uvp > prijs) {
          sparenEl.textContent = 'Du sparst ' + euro(n * (uvp - prijs));
          sparenEl.hidden = false;
        } else {
          sparenEl.hidden = true;
        }
      } else {
        paketeEl.textContent = perPak ? 'Gib die Anzahl Pakete ein' : 'Gib deine Fläche ein';
        totaalEl.textContent = '–';
        sparenEl.hidden = true;
      }

      // Leeg veld: alleen de rustige hint, geen alert en geen grijze knop.
      // Het Burgundy blok en de uitgeschakelde knop pas bij een waarde onder het minimum.
      var leeg = !(invoer > 0);
      var teWeinig = !leeg && onderMinimum;

      if (teWeinig) {
        minimumTekst.textContent = perPak
          ? 'Bitte erhöhe die Anzahl, dann kannst du bestellen.'
          : 'Mit ' + schrijfGetal(invoer) + ' m² wären es ' + paketeTekst(n) +
            '. Bitte erhöhe deine Fläche, dann kannst du bestellen.';
      }
      minimum.hidden = !teWeinig;
      if (hint) {
        hint.hidden = !leeg;
        if (!leeg) hint.classList.remove('is-nadruk');
      }

      if (genoeg) genoeg.hidden = onderMinimum || !(voorraad >= 0 && n > 0 && n <= voorraad);

      zetKnop(!teWeinig && !uitverkocht);
    }

    // Klik op "In den Warenkorb" met een leeg veld: niet versturen, maar naar
    // het veld met de hint. Vangt het submit-event vóór Hyper's product-form af.
    form.parentElement.addEventListener(
      'submit',
      function (event) {
        if (event.target !== form || leesGetal(veld.value) > 0) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (hint) hint.classList.add('is-nadruk');
        veld.focus();
      },
      true
    );

    // Kleinste invoer die precies het minimum aantal pakken oplevert. Met
    // verschnitt is dat minder dan de minimale oppervlakte zelf (10,30 m² + 10 %
    // = 6 pakken = 11,34 m²); de knop noemt daarom pakken, geen m².
    function minimumInvoer() {
      if (perPak) return minPakete;
      var factor = metVerschnitt ? 1 + snijverlies / 100 : 1;
      var waarde = Math.floor(((minPakete * pak) / factor) * 100) / 100;
      while (pakketten(waarde) < minPakete) waarde = Math.round((waarde + 0.01) * 100) / 100;
      return waarde;
    }

    function naarMinimum() {
      veld.value = perPak ? String(minPakete) : schrijfGetal(minimumInvoer());
      bereken();
      veld.focus();
    }

    root.querySelectorAll('[data-solza-step]').forEach(function (knop) {
      knop.addEventListener('click', function () {
        var stap = parseInt(knop.dataset.solzaStep, 10);
        var huidig = leesGetal(veld.value);
        if (!(huidig > 0)) huidig = 0;
        var nieuw = Math.max(0, Math.round((huidig + stap) * 100) / 100);
        veld.value = nieuw > 0 ? schrijfGetal(nieuw) : '';
        bereken();
      });
    });

    veld.addEventListener('input', bereken);
    veld.addEventListener('keydown', function (event) {
      // Enter in het veld mag niet per ongeluk bestellen onder het minimum.
      if (event.key === 'Enter' && submit.disabled) event.preventDefault();
    });

    if (minKnop) minKnop.addEventListener('click', naarMinimum);

    if (verschnittKnop) {
      verschnittKnop.addEventListener('click', function () {
        metVerschnitt = !metVerschnitt;
        verschnittKnop.setAttribute('aria-pressed', metVerschnitt ? 'true' : 'false');
        verschnittKnop.textContent = metVerschnitt ? 'ohne Verschnitt rechnen' : 'mit ' + snijverlies + ' % Verschnitt rechnen';
        verschnittTekst.textContent = metVerschnitt ? 'Inklusive ' + snijverlies + ' % Verschnitt' : 'Ohne Verschnitt';
        bereken();
      });
    }

    bereken();
    initToebehoren(root, form);
    initLeverdatum(root);
  }

  /* ------------------------------------------------------------------------
     Leverdatum in werkdagen
     ------------------------------------------------------------------------ */

  function plusWerkdagen(start, aantal) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var geteld = 0;
    while (geteld < aantal) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) geteld += 1;
    }
    return d;
  }

  function datumTekst(d) {
    var dag = String(d.getDate()).padStart(2, '0');
    var maand = String(d.getMonth() + 1).padStart(2, '0');
    return DAGEN[d.getDay()] + ' ' + dag + '.' + maand + '.';
  }

  function initLeverdatum(root) {
    var el = root.querySelector('[data-solza-lieferdatum]');
    var min = parseInt(root.dataset.tageMin, 10);
    var max = parseInt(root.dataset.tageMax, 10);
    if (!el || !(min > 0) || !(max >= min)) return;
    var nu = new Date();
    el.textContent = 'Voraussichtlich ' + datumTekst(plusWerkdagen(nu, min)) + ' – ' + datumTekst(plusWerkdagen(nu, max));
  }

  /* ------------------------------------------------------------------------
     Toebehoren
     ------------------------------------------------------------------------ */

  function initToebehoren(root, form) {
    var wrap = root.querySelector('[data-solza-toebehoren]');
    if (!wrap) return;

    wrap.querySelectorAll('[data-solza-acc]').forEach(function (groep) {
      var toggle = groep.querySelector('[data-solza-acc-toggle]');
      var lijst = groep.querySelector('.solza-pdp-acc__lijst');
      var teller = groep.querySelector('[data-solza-acc-count]');

      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        lijst.hidden = open;
      });

      groep.querySelectorAll('[data-solza-acc-add]').forEach(function (knop) {
        knop.addEventListener('click', function () {
          var aan = knop.getAttribute('aria-pressed') !== 'true';
          knop.setAttribute('aria-pressed', aan ? 'true' : 'false');
          knop.querySelector('[data-label-off]').hidden = aan;
          knop.querySelector('[data-label-on]').hidden = !aan;
          var n = groep.querySelectorAll('[data-solza-acc-add][aria-pressed="true"]').length;
          teller.textContent = n + ' ausgewählt';
          teller.hidden = n === 0;
        });
      });
    });

    // Vóór Hyper's product-form (die luistert op het formulier zelf) de gekozen
    // toebehoren in de winkelwagen zetten. Daarna verstuurt het formulier
    // normaal, zodat de cart drawer alles in één keer toont.
    var bezig = false;
    form.parentElement.addEventListener(
      'submit',
      function (event) {
        if (event.target !== form || form.dataset.solzaAccKlaar === 'true') return;
        var gekozen = wrap.querySelectorAll('[data-solza-acc-add][aria-pressed="true"]');
        if (!gekozen.length) return;

        event.preventDefault();
        event.stopPropagation();
        if (bezig) return;
        bezig = true;

        var items = Array.prototype.map.call(gekozen, function (knop) {
          return { id: parseInt(knop.dataset.variantId, 10), quantity: 1 };
        });
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .catch(function () {
            /* Toebehoren mislukt: de vloer zelf moet toch in de winkelwagen. */
          })
          .then(function () {
            gekozen.forEach(function (knop) {
              knop.click(); // selectie leegmaken; ze zitten nu in de winkelwagen
            });
            form.dataset.solzaAccKlaar = 'true';
            form.requestSubmit(form.querySelector('[data-solza-submit]'));
            form.dataset.solzaAccKlaar = '';
            bezig = false;
          });
      },
      true
    );
  }

  /* ------------------------------------------------------------------------
     Proefmonster (Product Samples-app)
     ------------------------------------------------------------------------ */

  function initMuster(root) {
    var kaart = root.querySelector('[data-solza-muster]');
    var apps = root.querySelector('.solza-pdp-apps');
    if (!kaart || !apps) return;

    function appKnop() {
      return apps.querySelector('[product-samples-button], .product-samples-button');
    }

    function check() {
      var knop = appKnop();
      if (knop && !knop.disabled) {
        kaart.hidden = false;
        var hint = root.querySelector('[data-solza-muster-hint]');
        if (hint) hint.hidden = false;
        return true;
      }
      return false;
    }

    // Ligt er al een staal van dit product in de winkelwagen? De app zet de
    // eigenschap "Muster von" op de producttitel. Dan meldt de kaart dat.
    var titel = kaart.getAttribute('data-product-title') || '';
    function markeerAlsKlaar() {
      var sub = kaart.querySelector('[data-solza-muster-sub]');
      var klaar = kaart.querySelector('[data-solza-muster-klaar]');
      if (sub) sub.hidden = true;
      if (klaar) klaar.hidden = false;
    }
    function checkWinkelwagen() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          var gevonden = cart && cart.items && cart.items.some(function (item) {
            return item.properties && item.properties['Muster von'] === titel;
          });
          if (gevonden) markeerAlsKlaar();
          return gevonden;
        })
        .catch(function () { return false; });
    }
    if (titel) checkWinkelwagen();

    kaart.addEventListener('click', function () {
      var knop = appKnop();
      if (!knop) return;
      knop.click();
      // Herlaadt de app de pagina niet, kijk dan zelf even na.
      var pogingen = 0;
      var timer = setInterval(function () {
        pogingen += 1;
        checkWinkelwagen().then(function (ok) {
          if (ok || pogingen >= 8) clearInterval(timer);
        });
      }, 750);
    });

    if (check()) return;
    var observer = new MutationObserver(function () {
      if (check()) observer.disconnect();
    });
    observer.observe(apps, { childList: true, subtree: true, attributes: true });
    // Zet de app binnen 15 s geen knop, dan blijft de kaart weg.
    setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  function init() {
    document.querySelectorAll('.solza-pdp-koop').forEach(function (sectie) {
      var root = sectie.querySelector('[data-solza-koop]');
      if (!root) return;
      try {
        initKoop(root);
        initMuster(root);
      } catch (_fout) {
        /* Liever een stille rekenhulp dan een kapotte pagina. */
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
